<!-- <input type="checkbox" id="toggle"> -->
<mat-slide-toggle matTooltipPosition="above" [matTooltip]="isChecked ? 'Светла цветова схема' : 'Тъмна цветова схема'" color="primary" (change)="toggleValueChanged($event)" [(ngModel)]="isChecked"></mat-slide-toggle>
